enum ContactHistoryTypes {
    ADD_CONTACT_HISTORY = 'ADD_CONTACT_HISTORY',
    REMOVE_CONTACT_HISTORY = 'REMOVE_CONTACT_HISTORY',
    SET_CH_INTERACTIONS = 'SET_CH_INTERACTIONS',
    SET_CH_SELECTED_INSTANCE = 'SET_CH_SELECTED_INSTANCE',
    DESELECT_CONTACT_HISTORY_INSTANCE = 'DESELECT_CONTACT_HISTORY_INSTANCE',
    SELECT_CH_INTERACTION = 'SELECT_CH_INTERACTION',
    ADD_CH_INTERACTION_TRANSCRIPT = 'ADD_CH_INTERACTION_TRANSCRIPT',
    SORT_CH_INTERACTIONS = 'SORT_CH_INTERACTIONS',
    ADD_CH_AUTOMATED_RULES_AUDIT = 'ADD_CH_AUTOMATED_RULES_AUDIT',
    ADD_CH_QUEUED_TASKS_AUDIT = 'ADD_CH_QUEUED_TASKS_AUDIT',
    SET_CH_VIEW_PREVIOUS_EMAIL_MESSAGES = 'SET_CH_VIEW_PREVIOUS_EMAIL_MESSAGES',
    ADD_CH_TRANSFORMED_ATTACHMENTS = 'ADD_CH_TRANSFORMED_ATTACHMENTS'
}

export default ContactHistoryTypes;
